// extracted by mini-css-extract-plugin
export default {"wrapper":"SmallItem_wrapper__2pRyV","item":"SmallItem_item__aQwNe","title":"SmallItem_title__ft+kq","itemArt":"SmallItem_itemArt__BU9nB","found":"SmallItem_found__xwd-z"};